import { useDispatch } from 'react-redux';
import { COURSE_BANNER_CLICK } from 'constants/gtmEvent';
import {
  clearGroupCourseListForHome,
  fetchCourseBanners,
  fetchCourseGradeLevels,
  fetchCourseListWithGroup,
  fetchGroupCourseListForHome,
  updateCourseHomeCurrentPage,
  updateCourseSelectedGradeLevel,
} from 'reduxModules/course/action';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';

export default function useGetDispatchActions() {
  const dispatch = useDispatch();

  const dispatchFetchBanners = payload => {
    dispatch(fetchCourseBanners(payload));
  };

  const dispatchFetchGradeLevels = () => {
    dispatch(fetchCourseGradeLevels());
  };

  const dispatchUpdateSelectedGradeLevel = payload => {
    dispatch(updateCourseSelectedGradeLevel(payload));
  };

  const dispatchFetchCourseList = groupIdList => {
    dispatch(
      fetchGroupCourseListForHome({
        groupIdList,
      }),
    );
  };

  const dispatchUpdateCurrentPage = page => {
    dispatch(updateCourseHomeCurrentPage({ page }));
  };

  const dispatchClearCourseList = () => {
    dispatch(clearGroupCourseListForHome());
  };

  const dispatchFetchGroupList = payload => {
    dispatch(fetchCourseListWithGroup(payload));
  };

  const dispatchBannerClickGTMEvent = data => {
    dispatch(
      sendGTMEvent({
        eventName: COURSE_BANNER_CLICK,
        data,
      }),
    );
  };

  return {
    dispatchUpdateSelectedGradeLevel,
    dispatchFetchBanners,
    dispatchFetchCourseList,
    dispatchUpdateCurrentPage,
    dispatchClearCourseList,
    dispatchFetchGradeLevels,
    dispatchFetchGroupList,
    dispatchBannerClickGTMEvent,
  };
}
